import { render, staticRenderFns } from "./Artifacts.vue?vue&type=template&id=5b56a09e&scoped=true&"
import script from "./Artifacts.vue?vue&type=script&lang=js&"
export * from "./Artifacts.vue?vue&type=script&lang=js&"
import style0 from "./Artifacts.vue?vue&type=style&index=0&id=5b56a09e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b56a09e",
  null
  
)

export default component.exports